module.exports = require("fork-ts-checker-webpack-plugin");